import { Team } from "./team";

export enum ExternalSmsMarketingProvider {
  ATTENTIVE = "attentive",
  KLAVIYO = "klaviyo",
  POSTSCRIPT = "postscript",
  SHOPIFY = "shopify",
}

export const marketingAttributionEvent = {
  CLICK: "click",
  OPEN: "open",
  DELIVERY: "delivery",
  BOUNCE: "bounce",
  SPAM: "spam",
  UNSUBSCRIBE: "unsubscribe",
} as const;
export type MarketingAttributionEvent =
  (typeof marketingAttributionEvent)[keyof typeof marketingAttributionEvent];

export const DEFAULT_SMS_SUFFIX = "\nSTOP to stop";

export function getSmsPrefix(
  team: Pick<Team, "name"> & {
    settings: { marketing?: { smsStoreName?: string | null } | null };
  },
): string {
  const name = team.settings.marketing?.smsStoreName || team.name || "";
  return name ? `${name}: ` : "";
}

export function isInternationalSms(phoneNumber: string | undefined): boolean {
  return !!phoneNumber && !phoneNumber.startsWith("+1");
}
